'use strict';
module.exports = require('@mindmup/mapjs-core/src/content/active-content-provider');
